<div class="login">
  <div class="bg">
    <img src="assets/login_background.png" />
  </div>
  <div class="login-content">
    <language-select class="position-absolute top-0 end-0 mt-2 me-2"></language-select>

    <div class="login-logo">
      @if (imageUrl$ | async) {
        <img [src]="imageUrl$ | async | safeUrl" alt="Logo">
      }
    </div>
    <router-outlet></router-outlet>
  </div>
  @if (isAgreementVisible) {
    <div class="cookie-agreement-box">
      <div class="sk-alert">
        <i class="fal fa-2x fa-fw fa-cookie"></i>
        <p class="mb-0 flex-grow-1">{{ 'message.CookieAgreementPopover' | translate }}</p>
        <sk-button class="bg-background"
                   data-test="accept-cookies-button"
                   [label]="'label.df.Understood' | translate"
                   (click)="acceptCookies()">
        </sk-button>
      </div>
    </div>
  }
  <div class="footer">
    <sk-toolbar class="p-2 text-rich text-secondary-light">
      <ng-template contentCenter>
        <sk-button
          data-test="show-imprint-modal"
          type="button"
          [label]="'label.Imprint' | translate"
          [appearance]="'link'"
          (click)="showInfoModal()">
        </sk-button>
      </ng-template>

      <ng-template contentRight>
        <sk-button
          data-test="clear-cache-btn"
          type="button"
          [label]="'message.Cache.ClearButton' | translate"
          [appearance]="'link'"
          (withConfirm)="clearMsalCache()"
          [withConfirmConfig]="{
            message: 'message.Cache.Confirmation' | translate,
            headerTitleText: 'label.ConfirmTitle' | translate,
            confirmBtnText: 'label.Yes' | translate,
            cancelBtnText: 'label.Cancel' | translate }">
        </sk-button>
      </ng-template>
    </sk-toolbar>
  </div>
</div>
